import React from "react";
import { Card } from "@/components/ui/card";

export default function DashaPeriods({ periods }) {
  if (!periods?.length) return null;
  const now = new Date().toISOString();
  return (
    <Card className="p-6 rounded-2xl border-slate-200 dark:border-slate-800 lg:col-span-2" data-testid="dasha-periods">
      <h3 className="font-display text-xl mb-3">Mahadasha &amp; Antardasha — Current and Next</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {periods.map(per => (
          <div key={per.label} className="rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden" data-testid={`dasha-period-${per.label.toLowerCase()}`}>
            <div className={`px-4 py-3 ${per.label === "Current" ? "bg-amber-50 dark:bg-amber-500/10" : "bg-slate-50 dark:bg-slate-800/60"}`}>
              <div className="text-[10px] uppercase tracking-widest text-slate-500">{per.label} Mahadasha</div>
              <div className="font-display text-lg">{per.planet}</div>
              <div className="text-xs font-mono text-slate-500">{per.start.slice(0, 10)} → {per.end.slice(0, 10)} · {per.years} yr</div>
            </div>
            <table className="w-full text-xs">
              <thead className="text-[10px] uppercase tracking-widest text-slate-500">
                <tr><th className="text-left px-3 py-1.5">Antardasha</th><th className="text-left px-3 py-1.5">Start</th><th className="text-left px-3 py-1.5">End</th></tr>
              </thead>
              <tbody>
                {per.antardashas.map(a => {
                  const running = a.start <= now && now <= a.end;
                  return (
                    <tr key={`${per.label}-${a.planet}`} className={`border-t border-slate-100 dark:border-slate-800 ${running ? "bg-amber-100/70 dark:bg-amber-500/20 font-semibold" : ""}`}>
                      <td className="px-3 py-1.5">{per.planet} / {a.planet}{running && <span className="ml-1 text-amber-700">• now</span>}</td>
                      <td className="px-3 py-1.5 font-mono">{a.start.slice(0, 10)}</td>
                      <td className="px-3 py-1.5 font-mono">{a.end.slice(0, 10)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </Card>
  );
}
